import { render, staticRenderFns } from "./DialogResetDemoChildren.vue?vue&type=template&id=1a7a4b7a"
import script from "./DialogResetDemoChildren.vue?vue&type=script&lang=js"
export * from "./DialogResetDemoChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports